import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFiles";
import "../../style/Fournisseur.css";
import { useParams } from "react-router-dom";
import axios from "axios";

import { useToasts } from "react-toast-notifications";

const API_URL = process.env.REACT_APP_API_URL;

function AdminFournisseurLentilles() {
  const [fournisseur, setFournisseur] = useState([]);
  const { fournisseurId } = useParams();
  const { addToast } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFournisseur((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function submitForm(e) {
    e.preventDefault();
    axios
      .put(`${API_URL}/api/lentilles/${fournisseurId}`, fournisseur)
      .then((res) => res.data)
      .then(() => {
        addToast("fournisseur modifié !", {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  useEffect(() => {
    function getFournisseur() {
      axios
        .get(`${API_URL}/api/lentilles/${fournisseurId}`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseur(data);
        });
    }

    getFournisseur();
  }, []);

  return (
    <div className="fournisseurMain">
      <a
        href={fournisseur.site_internet}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>
          {fournisseur.id ? (
            <img
              src={`${API_URL}/images/fournisseurs-lentilles/${fournisseur.id}.png`}
              alt="Logo"
              className="fournisseurLogo"
            />
          ) : (
            "Loading"
          )}
          <h1>
            {fournisseur.nom
              ? `${fournisseur.nom
                  .charAt(0)
                  .toUpperCase()}${fournisseur.nom.slice(1)}`
              : null}
          </h1>
        </span>
      </a>
      <h2>Contact</h2>
      <form onSubmit={submitForm}>
        Nom :{" "}
        <input
          type="text"
          value={fournisseur.nom}
          name="nom"
          onChange={handleChange}
        />
        <br />
        Adresse 1 :{" "}
        <input
          type="text"
          value={fournisseur.adresse_rue_1}
          name="adresse_rue_1"
          onChange={handleChange}
        />
        <br />
        Adresse 2 :{" "}
        <input
          type="text"
          value={fournisseur.adresse_rue_2}
          name="adresse_rue_2"
          onChange={handleChange}
        />
        <br />
        Code Postal :{" "}
        <input
          type="text"
          value={fournisseur.adresse_code_postal}
          name="adresse_code_postal"
          onChange={handleChange}
        />
        <br />
        Ville :{" "}
        <input
          type="text"
          value={fournisseur.adresse_ville}
          name="adresse_ville"
          onChange={handleChange}
        />
        <br />
        Pays :{" "}
        <input
          type="text"
          value={fournisseur.adresse_pays}
          name="adresse_pays"
          onChange={handleChange}
        />
        <br />
        Site internet :{" "}
        <input
          type="url"
          value={fournisseur.site_internet}
          name="site_internet"
          onChange={handleChange}
        />
        <br />
        Télephone :{" "}
        <input
          type="text"
          value={fournisseur.telephone}
          name="telephone"
          onChange={handleChange}
        />
        <br />
        Fax :{" "}
        <input
          type="text"
          value={fournisseur.fax}
          name="fax"
          onChange={handleChange}
        />
        <br />
        Adresse mail :{" "}
        <input
          type="email"
          value={fournisseur.email}
          name="email"
          onChange={handleChange}
        />
        <button type="submit">Enregistrer</button>
      </form>
      <UploadFile id={fournisseurId} category={"lentilles"} />
    </div>
  );
}

export default AdminFournisseurLentilles;
